import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useTranslation } from "../i18n";
import { useConfig } from "../_util/config-context";
export var EmptyTip = React.forwardRef(function EmptyTip(props, ref) {
    var classPrefix = useConfig().classPrefix;
    var t = useTranslation();
    var _a = props.emptyText, emptyText = _a === void 0 ? t.emptyText : _a, className = props.className, restProps = __rest(props, ["emptyText", "className"]);
    return (React.createElement("span", __assign({ ref: ref, className: classNames(classPrefix + "-action-state", className) }, restProps), typeof emptyText === "string" ? (React.createElement("span", { className: classPrefix + "-action-state__text", title: emptyText }, emptyText)) : (emptyText)));
});
EmptyTip.displayName = "EmptyTip";
//# sourceMappingURL=EmptyTip.js.map